import React from 'react';
import { Music, Award, Users, Zap } from 'lucide-react';

const About = () => {
  const features = [
    {
      icon: Music,
      title: "Premium Sound Quality",
      description: "State-of-the-art equipment and acoustically treated rooms for professional-grade recordings"
    },
    {
      icon: Award,
      title: "Expert Engineers",
      description: "Experienced team specializing in trap, drill, melodic, and underground sounds"
    },
    {
      icon: Users,
      title: "Artist-Focused",
      description: "Collaborative environment where your creative vision comes first"
    },
    {
      icon: Zap,
      title: "Efficient Workflow",
      description: "Fast turnaround times with polished results that meet industry standards"
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-purple-950/20 via-black to-black">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            About <span className="bg-gradient-to-r from-purple-400 to-blue-400 bg-clip-text text-transparent">High Quality Studios</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-3xl mx-auto">
            Where passion meets precision
          </p>
        </div>

        {/* Story */}
        <div className="max-w-4xl mx-auto mb-16">
          <div className="bg-gradient-to-br from-purple-900/20 to-blue-900/20 backdrop-blur-sm border border-purple-500/20 rounded-xl p-8 md:p-12">
            <h3 className="text-2xl font-bold text-white mb-6">Our Story</h3>
            <div className="space-y-4 text-gray-300 leading-relaxed">
              <p>
                High Quality Studios was built on a simple belief: every artist deserves access to professional-grade recording facilities and expert engineering. Located in the heart of Brooklyn, we've created a space where creativity thrives and music comes to life.
              </p>
              <p>
                Our team of experienced engineers brings deep expertise in trap, drill, melodic, and underground production. Whether you're recording your first track or finishing an album, we provide the technical excellence and creative support to bring your vision to reality.
              </p>
              <p>
                We pride ourselves on our efficient workflow, state-of-the-art equipment, and most importantly, our commitment to understanding and elevating each artist's unique sound. From the moment you book to the final mix, we're dedicated to delivering results that exceed expectations.
              </p>
            </div>
          </div>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-purple-900/20 to-blue-900/20 backdrop-blur-sm border border-purple-500/20 rounded-xl p-6 text-center hover:border-purple-500/50 transition-all"
            >
              <div className="w-16 h-16 bg-purple-600/20 rounded-full flex items-center justify-center mx-auto mb-4 border border-purple-500/30">
                <feature.icon className="text-purple-400" size={32} />
              </div>
              <h4 className="text-white font-semibold mb-2">{feature.title}</h4>
              <p className="text-gray-400 text-sm">{feature.description}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default About;
